document.documentElement.classList.add('js');

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const revealItems = document.querySelectorAll('[data-reveal]');
if (reduceMotion || !('IntersectionObserver' in window)) {
  revealItems.forEach((item) => item.classList.add('is-visible'));
} else {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
  revealItems.forEach((item) => revealObserver.observe(item));
}

if (!reduceMotion) {
  const parallaxRoots = document.querySelectorAll('[data-parallax-root]');
  let ticking = false;

  const updateParallax = () => {
    parallaxRoots.forEach((root) => {
      const image = root.querySelector('[data-parallax-image]');
      if (!image) return;
      const rect = root.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      image.style.transform = `translate3d(0, ${progress * -24}px, 0) scale(1.04)`;
    });
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }, { passive: true });
  updateParallax();
}

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const price = select.closest('[data-product-section]')?.querySelector('[data-product-price]');
    const option = select.options[select.selectedIndex];
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  });
});
